import { IToastOptions, ToastType } from '~commonInfra/services/ToasterService';
import { CommonErrorCode, UploadingProfilePictureErrorCode } from '~commonInfra/utils/ErrorCodes';

import { SessionService } from '../../../src/commonInfra/services/SessionService';
import { Messages } from '../../codegen/Localize';
import { IFormDataPostRequestParams } from '../../httpClient/serverApi/types/IFormDataPostRequestParams';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../httpClient/WebHttpClient';

const maxImageSize = 5000000;
const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp'];

function handlePictureSubmit(domainName: string, username: string, newUserImage: Blob,
                            callback: (toastOptions: IToastOptions) => void) {

  let errorMessage: string =  validateImage(newUserImage);
  if (errorMessage) {
    callback ({
      type: ToastType.Error,
      text: errorMessage,
    });
    return;
  }
  // send request to server
  const params: IFormDataPostRequestParams = {
    formDataFields: [
      { 'domainName': domainName },
      { 'username': username },
      { 'updateUserImageInput': newUserImage },
      { 'XSRF-TOKEN': SessionService.getSessionId()}
    ],
    method: 'updateUserImage'
  };
  const updatePromise: Promise<any> = WebHttpClient.requestPostFormDataToRestApi(params);
  updatePromise.then((result: IResult) => {
    errorMessage = handlePictureSubmitResult(result);
    callback(errorMessage? {
        type: ToastType.Error,
        text: errorMessage
      } : null
    );
  });
}

// return toaster error message for user if any
function validateImage(userImage: Blob): string {
  // max image upload limit to be confirmed
  if (userImage.size > maxImageSize) {
    return Messages.uploadUserProfilePictureErrorFileLargerThan5Megabytes();
  }
  if (supportedFormats.indexOf(userImage.type) < 0) {
    return Messages.uploadUserProfilePictureErrorFileTypeNotSupported();
  }
  return null;
}

function handlePictureSubmitResult(result: any): string {
  if (!result.errors || !result.errors.length) {
    return null;
  }
  switch(result.errors[0].code) {
    case CommonErrorCode.FileSizeTooLarge:
      return Messages.uploadUserProfilePictureErrorFileLargerThan5Megabytes();
    case UploadingProfilePictureErrorCode.InvalidImage:
      return Messages.uploadUserProfilePictureErrorFileTypeNotSupported();
    case UploadingProfilePictureErrorCode.StorageException:
    default:
      return Messages.uploadUserProfilePictureErrorSaveError();
  }
}

export const ProfilePictureService = {handlePictureSubmit, validateImage};
